<!-- layout.component.html -->
<header class="bg-white text-black p-4 shadow-md">
  <div class="max-w-7xl mx-auto flex items-center justify-between">
    <a href="https://zonapasajes.com.ar"><img src="assets/images/logo.png" alt="Zona Pasajes" class="h-10"> </a>
    <div class="flex items-center space-x-4 md:flex hidden">
      <a routerLink="/" mat-button color="tertiary" class="block text-left hover:bg-[#1f46ea] hover:text-white text-black font-semibold px-10 py-2 rounded-md no-underline">Inicio</a>
      <a routerLink="/refund" mat-button color="tertiary" class="hover:bg-[#1f46ea] hover:text-white text-black font-semibold px-10 py-2 rounded-md no-underline" [ngClass]="{'bg-[#1f46ea] text-white': url() == '/refund'}">Devolver pasajes</a>
      <a routerLink="/resend" mat-button color="tertiary" class="hover:bg-[#1f46ea] hover:text-white text-black font-semibold px-10 py-2 rounded-md no-underline" [ngClass]="{'bg-[#1f46ea] text-white': url() == '/resend'}">Reenviar pasajes</a>
      <a routerLink="/login" *ngIf="!isLoggedIn()" mat-button color="primary" class="bg-green-600 hover:bg-green-700 text-white font-semibold px-10 py-2 rounded-md no-underline">Iniciar sesión</a>
      <a routerLink="/register" *ngIf="!isLoggedIn()" mat-button color="primary" class="bg-green-600 hover:bg-green-700 text-white font-semibold px-10 py-2 rounded-md no-underline">Registrarse</a>
      <app-user-menu *ngIf="isLoggedIn()"></app-user-menu>
    </div>

    <!-- Mobile menu button -->
    <div class="md:hidden">
      <button mat-icon-button color="primary" (click)="toggleMenu()" class="bg-white border-none cursor-pointer mobile-menu-button">
        <mat-icon class="text-black">{{ isMobileMenuOpen() ? 'close' : 'menu' }}</mat-icon>
      </button>
    </div>
  </div>

  <!-- Mobile menu content -->
  <div class="md:hidden mobile-menu-content shadow-md" *ngIf="isMobileMenuOpen()">
    <div class="mt-4 space-y-2 border-t pt-4">
      <a routerLink="/" mat-button color="tertiary" class="block text-left hover:bg-[#1f46ea] hover:text-white text-black font-semibold px-4 py-3 rounded-md no-underline">Inicio</a>
      <a routerLink="/refund" mat-button color="tertiary" class="block text-left hover:bg-[#1f46ea] hover:text-white text-black font-semibold px-4 py-3 rounded-md no-underline" [ngClass]="{'bg-[#1f46ea] text-white': url() == '/refund'}">Devolver pasajes</a>
      <a routerLink="/resend" mat-button color="tertiary" class="block text-left hover:bg-[#1f46ea] hover:text-white text-black font-semibold px-4 py-3 rounded-md no-underline" [ngClass]="{'bg-[#1f46ea] text-white': url() == '/resend'}">Reenviar pasajes</a>
      <mat-divider></mat-divider>
      <a routerLink="/login" *ngIf="!isLoggedIn()" mat-button color="tertiary"    class="block text-left text-black font-semibold px-4 py-3 rounded-md no-underline">Iniciar sesión</a>
      <a routerLink="/register" *ngIf="!isLoggedIn()" mat-button color="tertiary" class="block text-left text-black font-semibold px-4 py-3 rounded-md no-underline">Registrarse</a>
      <a routerLink="/account" *ngIf="isLoggedIn()" mat-button color="tertiary"   class="block text-left text-black font-semibold px-4 py-3 rounded-md no-underline">Mi cuenta</a>
    </div>
  </div>
</header>

<main class="min-h-[calc(100vh-177px)] bg-gray-50 py-6 px-4 md:px-8">
  <div class="max-w-7xl mx-auto">
    <router-outlet></router-outlet>
  </div>
</main>

<footer class="bg-gray-100 border-t text-center py-4 text-sm text-gray-600">
  <div class="max-w-7xl mx-auto">
    &copy; 2026 ZonaPasajes - Todos los derechos reservados - <a
      href="https://zonapasajes.com.ar/terminos-y-condiciones-de-uso/" target="_blank">Términos y Condiciones de Uso</a>
    - Atención al cliente: <a
      href="mailto:atencionalcliente@zonapasajes.com.ar">atencionalcliente&#64;zonapasajes.com.ar</a>
  </div>
</footer>